
import { useState,useEffect } from "react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { useNavigate } from "react-router-dom";
import Leftsidebar from "./sidebar/leftsidebar";
import LeftResponsivesidebar from "./sidebar/left-responsive";
import Rightsidebar from "./sidebar/rightsidebar";
import RightResponsivesidebar from "./sidebar/right-responsive";
import Headmenu from "./sidebar/headmenu";
// import "emoji-mart/css/emoji-mart.css"; // Import the CSS for emoji picker
import axios from "axios"; // Add at the top if not already
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
// import data from '@emoji-mart/data';
import Picker from '@emoji-mart/react';

// Family Wallet - Siddharth
const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/$/, "");

export default function Wallet() {
  const [showAddAmount, setShowAddAmount] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
 const [amount, setAmount] = useState(""); // track input amount
  const [loading, setLoading] = useState(false);
  const [balance, setBalance] = useState(null);
  const [message, setMessage] = useState("");
  const [transactions, setTransactions] = useState([]);
const [currency, setCurrency] = useState("$"); // Add this state if you want to support currency selection
 const stripe = useStripe();
  const elements = useElements();


  const [filterTab, setFilterTab] = useState("All");
  const [searchText, setSearchText] = useState("");
  const [showFamilyModal, setShowFamilyModal] = useState(false);
  const [familyName, setFamilyName] = useState("");
  const [memberSearch, setMemberSearch] = useState("");
  const [relationship, setRelationship] = useState("");
  // Family Wallet - Siddharth
  const [searchResults, setSearchResults] = useState([]);
  const [pendingMembers, setPendingMembers] = useState([]);
  const [creatingFamilyWallet, setCreatingFamilyWallet] = useState(false);
  const [familyCreated, setFamilyCreated] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [showLoadMoney, setShowLoadMoney] = useState(false);
  const [loadAmount, setLoadAmount] = useState("");
  const [loadCurrency, setLoadCurrency] = useState("$");
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  // Family Wallet - Siddharth
  const [familyMembers, setFamilyMembers] = useState([]);
  // Family Wallet - Siddharth
  const [selectedMember, setSelectedMember] = useState(null);
  const [invitingMemberId, setInvitingMemberId] = useState(null);
  const [initiatingLoadMoney, setInitiatingLoadMoney] = useState(false);
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [confirmResult, setConfirmResult] = useState(null);
  // Family Wallet - Siddharth
  const [myInvites, setMyInvites] = useState([]);
  const [respondingInviteId, setRespondingInviteId] = useState(null);
  const [amountUsed, setAmountUsed] = useState(0);
  const tabs = ["Add Amount", "Select Your Payment Mode", "Payment"];
  //  const handleAddAmount = async () => {
  //         const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Retrieve token

  //   if (!amount || amount <= 0) {
  //     alert("Please enter a valid amount");
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     const response = await fetch("https://staging-api.pipaan.com/api/wallet/load", {
  //       method: "POST",
  //       headers: {
  //             token: `${token}`, // ✅ Ensure proper format
  //             "Content-Type": "application/json",
  //           },
  //       body: JSON.stringify({ amount: Number(amount) }), // send amount
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //       setBalance(data.result.balance);
  //       setMessage(data.result.message);
  //       setActiveTab(1); // move to next step only on success
  //     } else {
  //       alert("Failed to load amount");
  //     }
  //   } catch (error) {
  //     console.error("Error loading wallet:", error);
  //     alert("Something went wrong!");
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const handleAddAmount = () => {
  if (!amount || amount <= 0) {
    alert("Please enter a valid amount");
    return;
  }
  setActiveTab(1); // Move to payment mode tab
};

const handleWalletPayment = async () => {
  if (!amount || amount <= 0) {
    alert("Please enter a valid amount");
    return;
  }
   if (!stripe || !elements) {
      alert("Stripe not loaded");
      return;
    }
  setLoading(true);
  try {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    // Family Wallet - Siddharth: was hardcoded to the staging server, so this call silently hit the
    // wrong backend for anyone running locally - use API_BASE_URL like the rest of the file
    const { data } = await axios.post(
      `${API_BASE_URL}/wallet/create-payment`,
      {
        amount: Number(amount),
        currency: currency === "$" ? "usd" : currency === "₹" ? "inr" : "eur",
        method_type: "wallet",    // or whatever type you want to specify
        metadata: {},
      },
      {
        headers: {
          token: token,
        },
      }
    );
    // 2. Confirm payment with Stripe
      const result = await stripe.confirmCardPayment(
        data.result.client_secret,
        {
          payment_method: {
            card: elements.getElement(CardElement),
          },
        }
      );
      if (result.error) {
        setMessage(`❌ ${result.error.message}`);
      } else if (result.paymentIntent.status === "succeeded") {
        setMessage("✅ Payment successful!");
          fetchWalletData(); // <-- Refresh balance

        setActiveTab(0);
      }
    } catch (err) {
      alert("Payment failed");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
                  const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Retrieve token

    // ✅ Fetch balance + transactions
    const fetchWalletData = async () => {
                const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken"); // Retrieve token

      try {
        setLoading(true);
        // Family Wallet - Siddharth: was hardcoded to the staging server, so Current Balance and
        // Transactions never reflected local data - use API_BASE_URL like the rest of the file
        const response = await fetch(`${API_BASE_URL}/wallet/balance`, {
          method: "GET",
          headers: {
              token: `${token}`, // ✅ Ensure proper format
              "Content-Type": "application/json",
            },
        });

        const data = await response.json();
        if (data.success) {
          setBalance(data.result.balance);
          setTransactions(data.result.walletTransactions || []);
        } else {
          console.error("Failed to fetch wallet data:", data.message);
        }
      } catch (err) {
        console.error("Error fetching wallet:", err);
      } finally {
        setLoading(false);
      }
    };

      useEffect(() => {

    fetchWalletData();
  }, [token]);

  // Family Wallet - Siddharth
  const fetchFamilyWalletData = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await fetch(`${API_BASE_URL}/family_wallet/get-details`, {
        method: "GET",
        headers: {
          token: `${token}`,
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();
      if (data.success) {
        setFamilyCreated(!!data.result.family_wallet);
        setFamilyName(data.result.family_wallet ? data.result.family_wallet.name : "");
        setFamilyMembers(data.result.members || []);
        setAmountUsed(data.result.amount_used || 0);
      } else {
        console.error("Failed to fetch family wallet data:", data.message);
      }
    } catch (err) {
      console.error("Error fetching family wallet:", err);
    }
  };

  // Family Wallet - Siddharth
  useEffect(() => {
    fetchFamilyWalletData();
  }, []);

  // Family Wallet - Siddharth
  const fetchMyInvites = async () => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await fetch(`${API_BASE_URL}/family_wallet/my-invites`, {
        method: "GET",
        headers: {
          token: `${token}`,
          "Content-Type": "application/json",
        },
      });
      const data = await response.json();
      if (data.success) {
        setMyInvites(data.result || []);
      }
    } catch (err) {
      console.error("Error fetching family wallet invites:", err);
    }
  };

  // Family Wallet - Siddharth
  useEffect(() => {
    fetchMyInvites();
  }, []);

  // Family Wallet - Siddharth
  const respondToInvite = async (family_wallet_member_id, status) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    setRespondingInviteId(family_wallet_member_id);
    try {
      const response = await fetch(`${API_BASE_URL}/family_wallet/respond-invite`, {
        method: "POST",
        headers: {
          token: `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ family_wallet_member_id, status }),
      });
      const data = await response.json();
      if (data.success) {
        await fetchMyInvites();
        await fetchFamilyWalletData();
      } else {
        alert(data.message || "Failed to respond to invite");
      }
    } catch (err) {
      console.error("Error responding to invite:", err);
      alert("Failed to respond to invite");
    } finally {
      setRespondingInviteId(null);
    }
  };

  // Family Wallet - Siddharth: always reset the modal's search/staging state on close so it reopens fresh
  const closeFamilyModal = () => {
    setShowFamilyModal(false);
    setMemberSearch("");
    setSearchResults([]);
    setRelationship("");
    setPendingMembers([]);
    setFamilyName("");
  };

  // Family Wallet - Siddharth
  useEffect(() => {
    if (!memberSearch.trim()) {
      setSearchResults([]);
      return;
    }
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    const searchMembers = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/family_wallet/search-members`, {
          method: "POST",
          headers: {
            token: `${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ search: memberSearch }),
        });
        const data = await response.json();
        if (data.success) {
          setSearchResults(data.result || []);
        }
      } catch (err) {
        console.error("Error searching family members:", err);
      }
    };
    searchMembers();
  }, [memberSearch, isEditMode]);

  // Family Wallet - Siddharth
  const addPendingMember = (result) => {
    if (!relationship) {
      alert("Please select a relationship first");
      return;
    }
    if (pendingMembers.some((m) => m.family_member_id === result.family_member_id)) {
      alert("This member has already been added to the list");
      return;
    }
    setPendingMembers([
      ...pendingMembers,
      { family_member_id: result.family_member_id, relationship_type: relationship, user: result.user },
    ]);
    setMemberSearch("");
    setRelationship("");
  };

  // Family Wallet - Siddharth
  const removePendingMember = (family_member_id) => {
    setPendingMembers(pendingMembers.filter((m) => m.family_member_id !== family_member_id));
  };

  // Family Wallet - Siddharth
  const createFamilyWallet = async () => {
    if (!familyName) {
      alert("Please enter a family wallet name");
      return;
    }
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    setCreatingFamilyWallet(true);
    try {
      const response = await fetch(`${API_BASE_URL}/family_wallet/create`, {
        method: "POST",
        headers: {
          token: `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: familyName,
          members: pendingMembers.map((m) => ({
            family_member_id: m.family_member_id,
            relationship_type: m.relationship_type,
          })),
        }),
      });
      const data = await response.json();
      if (data.success) {
        await fetchFamilyWalletData();
        setFamilyName("");
        setPendingMembers([]);
        setMemberSearch("");
        setRelationship("");
        setSearchResults([]);
        setShowFamilyModal(false);
      } else {
        alert(data.message || "Failed to create family wallet");
      }
    } catch (err) {
      console.error("Error creating family wallet:", err);
      alert("Failed to create family wallet");
    } finally {
      setCreatingFamilyWallet(false);
    }
  };

  // Family Wallet - Siddharth
  const inviteMemberNow = async (result) => {
    if (!relationship) {
      alert("Please select a relationship first");
      return;
    }
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    setInvitingMemberId(result.family_member_id);
    try {
      const response = await fetch(`${API_BASE_URL}/family_wallet/invite-member`, {
        method: "POST",
        headers: {
          token: `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          family_member_id: result.family_member_id,
          relationship_type: relationship,
        }),
      });
      const data = await response.json();
      if (data.success) {
        await fetchFamilyWalletData();
        setMemberSearch("");
        setRelationship("");
        setSearchResults([]);
      } else {
        alert(data.message || "Failed to send invite");
      }
    } catch (err) {
      console.error("Error inviting family member:", err);
      alert("Failed to send invite");
    } finally {
      setInvitingMemberId(null);
    }
  };

  // Family Wallet - Siddharth
  const removeFamilyMember = async (family_wallet_member_id) => {
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    try {
      const response = await fetch(`${API_BASE_URL}/family_wallet/remove-member`, {
        method: "POST",
        headers: {
          token: `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ family_wallet_member_id }),
      });
      const data = await response.json();
      if (data.success) {
        await fetchFamilyWalletData();
      } else {
        alert(data.message || "Failed to remove member");
      }
    } catch (err) {
      console.error("Error removing family member:", err);
      alert("Failed to remove member");
    }
  };

  // Family Wallet - Siddharth
  const PRESET_LOAD_AMOUNTS = ["15.000", "25.000", "50.000", "100.000"];
  const parseLoadAmount = (value) =>
    PRESET_LOAD_AMOUNTS.includes(value) ? Number(value.replace(/\.000$/, "")) : Number(value);

  // Family Wallet - Siddharth
  const initiateLoadMoney = async () => {
    const amount = parseLoadAmount(loadAmount);
    if (!selectedMember || !amount || amount <= 0) {
      alert("Please select a valid amount");
      return;
    }
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    setInitiatingLoadMoney(true);
    try {
      const response = await fetch(`${API_BASE_URL}/family_wallet/load-money/initiate`, {
        method: "POST",
        headers: {
          token: `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          family_wallet_member_id: selectedMember.family_wallet_member_id,
          amount,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setOtpError("");
        setShowOtpModal(true);
      } else {
        alert(data.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error("Error initiating load money:", err);
      alert("Failed to send OTP");
    } finally {
      setInitiatingLoadMoney(false);
    }
  };

  // Family Wallet - Siddharth
  const confirmLoadMoneyOtp = async () => {
    const amount = parseLoadAmount(loadAmount);
    const token = sessionStorage.getItem("accessToken") || localStorage.getItem("accessToken");
    setVerifyingOtp(true);
    setOtpError("");
    try {
      const response = await fetch(`${API_BASE_URL}/family_wallet/load-money/confirm`, {
        method: "POST",
        headers: {
          token: `${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          family_wallet_member_id: selectedMember.family_wallet_member_id,
          amount,
          otp: otpValue,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setConfirmResult({ ...data.result, amount });
        setShowOtpModal(false);
        setOtpValue("");
        setShowSuccessModal(true);
        fetchFamilyWalletData();
        fetchWalletData();
      } else {
        setOtpError(data.message || "Invalid or expired OTP");
      }
    } catch (err) {
      console.error("Error confirming load money:", err);
      setOtpError("Failed to verify OTP");
    } finally {
      setVerifyingOtp(false);
    }
  };

  const filteredTransactions = transactions.filter((txn) => {
    // Family Wallet - Siddharth: was checking txn.type === "load" (only recognized "load" as credit,
    // and treated every other type as debit). That broke once top_up/family_receive/family_send existed,
    // since the backend already computes the correct credit/debit label as txn.txn_type - use that instead.
    const matchesTab =
      filterTab === "All" ||
      (filterTab === "Credit" && txn.txn_type === "credit") ||
      (filterTab === "Debit" && txn.txn_type === "debit");
    const matchesSearch = txn.description
      ?.toLowerCase()
      .includes(searchText.toLowerCase());
    return matchesTab && matchesSearch;
  });

  return (
    <div className="dashboard w-full min-h-screen grid grid-cols-[17%_83%]">
      <div className="h-full">
        <Leftsidebar />
      </div>

      <main className="flex-1 p-6 pl-8">
        <LeftResponsivesidebar />
        <Headmenu />

        <main className="grid grid-cols-[78%_20%]">
          <div className="lg:pr-5 space-y-4">

            {/* ── Wallet Main View ── */}
            {!showAddAmount && !showLoadMoney && (
              <>
                <div className="flex items-center justify-between">
                  <h1 className="text-2xl font-bold text-gray-900">Wallet</h1>
                  {/* <button
                    type="button"
                    className="bg-white border border-[#095228] text-[#095228] font-semibold px-4 py-2 rounded-full text-sm hover:bg-[#EBF8ED] transition"
                    onClick={() => setShowOtpModal(true)}
                  >
                    View OTP Popup
                  </button> */}
                </div>

                {/* 1. Balance Card */}
                <div className="bg-gradient-to-r from-cyan-400 to-green-400 rounded-2xl px-6 py-6 flex items-center justify-between">
                  <div>
                    <p className="text-white text-sm font-medium opacity-80">Current Balance</p>
                    <h2 className="text-white text-4xl font-semibold mt-1">
                      $ {balance ?? "0.00"}
                    </h2>
                  </div>
                  <button
                    className="bg-white text-green-800 font-semibold px-6 py-2.5 rounded-full shadow hover:bg-gray-50 transition"
                    onClick={() => setShowAddAmount(true)}
                  >
                    + Add Balance
                  </button>
                </div>

                {/* Family Wallet - Siddharth: pending invites for this user, shown only when there are any */}
                {myInvites.length > 0 && (
                  <div className="bg-white rounded-2xl shadow-sm p-5 space-y-3">
                    <h3 className="text-lg font-bold text-gray-900">Pending Family Invites</h3>
                    {myInvites.map((invite) => (
                      <div key={invite.family_wallet_member_id} className="p-[0.5px] rounded-2xl bg-gradient-to-r from-[#98911F] to-[#39B54A]">
                        <div className="flex items-center justify-between bg-[#FEFDEB] rounded-2xl px-4 py-3">
                          <div className="flex items-center gap-3">
                            <img
                              src={invite.owner?.profile_picture_url || require("../assets/images/golive-prf.png")}
                              alt="owner"
                              className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                            />
                            <div>
                              <p className="font-bold text-gray-900 text-sm">
                                {invite.owner?.first_name} {invite.owner?.last_name} invited you to {invite.family_wallet?.name}
                              </p>
                              <p className="text-xs text-gray-400 mt-0.5">as {invite.relationship_type}</p>
                            </div>
                          </div>
                          <div className="flex items-center gap-2">
                            <button
                              disabled={respondingInviteId === invite.family_wallet_member_id}
                              className="bg-[#095228] text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-green-900 transition whitespace-nowrap disabled:opacity-60"
                              onClick={() => respondToInvite(invite.family_wallet_member_id, "accepted")}
                            >
                              Accept
                            </button>
                            <button
                              disabled={respondingInviteId === invite.family_wallet_member_id}
                              className="bg-[#F9E9EA] border border-[#BE1F2E] text-[#BE1F2E] text-xs font-semibold px-3 py-2 rounded-full hover:opacity-80 transition disabled:opacity-60"
                              onClick={() => respondToInvite(invite.family_wallet_member_id, "rejected")}
                            >
                              Reject
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* 2. Family Wallet */}
                <div className="space-y-3">
                  <div className="flex items-center justify-between py-1">
                    <div className="flex items-start gap-2">
                      <img src={require("../assets/images/icons/friendsandfollowers.png")} alt="family wallet" className="w-5 h-5 mt-0.5 [filter:invert(24%)_sepia(80%)_saturate(700%)_hue-rotate(108deg)_brightness(85%)_contrast(102%)]" />
                      <div>
                        <span className="font-bold text-gray-900 text-base block">
                          {familyCreated && familyName ? familyName : "Family Wallet"}
                        </span>
                        {familyCreated && (
                          // Family Wallet - Siddharth
                          <span className="text-[#095228] text-xs font-medium">Amount Used : $ {amountUsed}</span>
                        )}
                      </div>
                    </div>
                    {/* Family Wallet - Siddharth: refetch on open so the modal always shows current data */}
                    <button
                      className="font-bold text-gray-900 underline underline-offset-2 text-sm hover:text-green-700 transition"
                      onClick={() => {
                        setIsEditMode(familyCreated);
                        setShowFamilyModal(true);
                        fetchFamilyWalletData();
                      }}
                    >
                      {familyCreated ? "+ Add Member" : "+ Add Family Wallet"}
                    </button>
                  </div>

                  {/* Family members on home page */}
                  {familyCreated && (
                    <div className="space-y-3">
                      {/* Family Wallet - Siddharth */}
                      {familyMembers.map((member) => (
                        <div key={member.family_wallet_member_id} className="p-[0.5px] rounded-2xl bg-gradient-to-r from-[#98911F] to-[#39B54A]">
                          <div className="flex items-center justify-between bg-[#FEFDEB] rounded-2xl px-4 py-3">
                            <div className="flex items-center gap-3">
                              <img
                                src={require("../assets/images/golive-prf.png")}
                                alt="member"
                                className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                              />
                              <div>
                                <div className="flex items-center gap-1.5 flex-wrap">
                                  <p className="font-bold text-gray-900 text-sm">{member.user.first_name} {member.user.last_name}</p>
                                  <span className="text-gray-900 text-[10px] font-bold px-2 py-0.5 rounded-full bg-gradient-to-r from-[#A1D2FF] to-[#00E0C6]">{member.relationship_type}</span>
                                  {/* Family Wallet - Siddharth: status badge for all three states, not just pending */}
                                  {member.status === "pending" && (
                                    <span className="bg-[#F9E9EA] text-[#BE1F2E] text-[10px] font-semibold px-2 py-0.5 rounded">Request Pending</span>
                                  )}
                                  {member.status === "accepted" && (
                                    <span className="bg-[#E6F7EC] text-[#095228] text-[10px] font-semibold px-2 py-0.5 rounded">Active</span>
                                  )}
                                  {member.status === "rejected" && (
                                    <span className="bg-[#F9E9EA] text-[#BE1F2E] text-[10px] font-semibold px-2 py-0.5 rounded">Rejected</span>
                                  )}
                                </div>
                                <p className="text-xs text-gray-400 mt-0.5">@{member.user.username}</p>
                              </div>
                            </div>
                            <div className="flex items-center gap-2">
                              {/* Family Wallet - Siddharth: caption removed per feedback */}
                              <div className="text-right mr-1">
                                <p className="font-bold text-gray-900 text-base">$ {member.current_balance}</p>
                              </div>
                              {member.status === "accepted" ? (
                                <button
                                  className="bg-[#095228] text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-green-900 transition whitespace-nowrap"
                                  onClick={() => {
                                    setSelectedMember(member);
                                    setShowLoadMoney(true);
                                  }}
                                >
                                  + Load Money
                                </button>
                              ) : (
                                <button disabled className="bg-gray-300 text-black text-xs font-semibold px-3 py-2 rounded-full cursor-not-allowed whitespace-nowrap shadow-[0px_1px_2px_0px_rgba(13,13,18,0.06)]">
                                  + Load Money
                                </button>
                              )}
                              {/* Family Wallet - Siddharth: confirm before removing */}
                              <button
                                className="bg-[#F9E9EA] border border-[#BE1F2E] text-[#BE1F2E] text-xs font-semibold px-3 py-2 rounded-full flex items-center gap-1.5 hover:opacity-80 transition"
                                onClick={() => {
                                  if (window.confirm(`Are you sure you want to remove ${member.user.first_name} ${member.user.last_name}?`)) {
                                    removeFamilyMember(member.family_wallet_member_id);
                                  }
                                }}
                              >
                                <img src={require("../assets/images/icons/trash.png")} alt="delete" className="w-3.5 h-3.5" />
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* 3. Transactions */}
                <div className="bg-white rounded-2xl shadow-sm p-5">
                  <h3 className="text-lg font-bold text-gray-900 mb-4">Transactions</h3>

                  {/* Filter row */}
                  <div className="flex items-center justify-between mb-5 flex-wrap gap-3">
                    <div className="flex items-center gap-2 bg-[#EBF8ED] px-2 py-1.5 rounded-full">
                      {["All", "Credit", "Debit"].map((tab) => (
                        <button
                          key={tab}
                          onClick={() => setFilterTab(tab)}
                          className={`px-5 py-1.5 rounded-full text-sm font-semibold transition ${
                            filterTab === tab
                              ? "bg-[#095228] text-white"
                              : "bg-[#EBF8ED] text-[#095228] hover:bg-[#d4f0de]"
                          }`}
                        >
                          {tab}
                        </button>
                      ))}
                    </div>

                    <div className="flex items-center gap-2">
                      <button className=" transition">
                        <img src={require("../assets/images/icons/calendar-icon.png")} alt="calendar" className="w-5 h-5" />
                      </button>
                      <div className="flex items-center gap-2 rounded-lg px-3 py-1.5">
                        <img src={require("../assets/images/icons/Search-2.png")} alt="search" className="w-5 h-5" />
                        <input
                          type="text"
                          placeholder="search"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          className="outline-none text-sm text-gray-600 w-24 bg-transparent"
                        />
                      </div>
                    </div>
                  </div>

                  {/* Transaction list */}
                  {loading ? (
                    <p className="text-gray-400 text-sm">Loading transactions...</p>
                  ) : filteredTransactions.length > 0 ? (
                    <div className="divide-y divide-gray-100">
                      {filteredTransactions.map((txn) => {
                        const isCredit = txn.type === "load";
                        return (
                          <div key={txn.id} className="flex items-center justify-between py-3.5">
                            <div className="flex items-center gap-3">
                              <span className={`w-9 h-9 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${isCredit ? "bg-green-100 text-green-600" : "bg-red-100 text-red-500"}`}>
                                {isCredit ? "✓" : "↗"}
                              </span>
                              <div>
                                <p className="font-semibold text-gray-800 text-sm">{txn.description}</p>
                                <p className="text-xs text-gray-400 mt-0.5">{new Date(txn.created_at).toLocaleString()}</p>
                              </div>
                            </div>
                            <span className={`font-bold text-sm ${isCredit ? "text-green-500" : "text-red-500"}`}>
                              {isCredit ? "+" : "-"}${txn.amount}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <p className="text-gray-400 text-sm">No transactions found</p>
                  )}
                </div>
              </>
            )}

            {/* ── Load Money View ── */}
            {showLoadMoney && (
              <div className="space-y-6">
                {/* Header */}
                <div className="flex items-center justify-between">
                  <h1 className="text-2xl font-bold text-gray-900">Load Money</h1>
                  <button
                    className="flex items-center gap-1.5 text-[#095228] font-bold text-sm tracking-wide hover:opacity-80 transition"
                    onClick={() => setShowLoadMoney(false)}
                  >
                    <span className="w-5 h-5 rounded-full bg-[#DFF3E4] flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="3">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
                      </svg>
                    </span>
                    BACK TO WALLET
                  </button>
                </div>

                {/* Balance Card */}
                <div className="bg-gradient-to-r from-cyan-400 to-green-400 rounded-2xl px-6 py-6">
                  <p className="text-white text-sm font-medium opacity-80">Current Balance</p>
                  <h2 className="text-white text-4xl font-semibold mt-1">$ {balance ?? "0"}</h2>
                </div>

                {/* Load Amount */}
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-4">Load Amount</h3>
                  <div className="grid sm:grid-cols-2 gap-8 max-w-2xl">
                    {/* Choose your amount */}
                    <div>
                      <p className="text-sm font-medium text-gray-700 mb-3">Choose your Amount</p>
                      <div className="flex flex-col gap-3">
                        {["15.000", "25.000", "50.000", "100.000"].map((amt) => (
                          <button
                            key={amt}
                            type="button"
                            onClick={() => setLoadAmount(amt)}
                            className={`flex items-center gap-2.5 border rounded-full px-4 py-3 text-sm font-medium transition ${
                              loadAmount === amt
                                ? "border-[#DFE1E7] bg-[#EBF8ED] text-gray-900"
                                : "border-[#DFE1E7] text-gray-700 hover:border-[#095228] hover:bg-[#EBF8ED]"
                            }`}
                          >
                            <img src={require("../assets/images/icons/greenwallet.png")} alt="" className="w-5 h-5" />
                            $ {amt}
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Other nominal */}
                    <div>
                      <p className="text-sm font-medium text-gray-700 mb-3">Other nominal</p>
                      <div className="flex items-center border border-[#DFE1E7] rounded-lg px-3 py-3 mb-4 bg-[#F3F8F5]">
                        <div className="flex items-center gap-1.5 pr-3 border-r border-gray-300">
                          <select
                            value={loadCurrency}
                            onChange={(e) => setLoadCurrency(e.target.value)}
                            className="appearance-none bg-transparent outline-none text-gray-700 font-medium cursor-pointer"
                          >
                            <option>$</option>
                            <option>₹</option>
                            <option>€</option>
                          </select>
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-[#333333] pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                          </svg>
                        </div>
                        <input
                          type="number"
                          className="flex-1 ml-3 outline-none bg-transparent text-right text-[#333333]"
                          placeholder="0"
                          value={!["15.000", "25.000", "50.000", "100.000"].includes(loadAmount) ? loadAmount : ""}
                          onChange={(e) => setLoadAmount(e.target.value)}
                        />
                      </div>
                      <button
                        type="button"
                        disabled={initiatingLoadMoney}
                        onClick={initiateLoadMoney}
                        className="w-full bg-[#095228] text-white font-semibold py-3 rounded-full hover:bg-green-900 transition disabled:opacity-60"
                      >
                        {initiatingLoadMoney ? "Sending OTP..." : "Load Amount"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* ── Add Balance Flow ── */}
            {showAddAmount && (
              <div className="max-w-4xl mx-auto p-6">
                <button
                  className="flex items-center gap-2 text-green-800 font-medium mb-6"
                  onClick={() => setShowAddAmount(false)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7" />
                  </svg>
                  <span>BACK TO WALLET</span>
                </button>

                <div className="flex justify-between items-center border-b border-gray-200 pb-3 mb-6 text-sm">
                  {tabs.map((tab, idx) => (
                    <button
                      key={idx}
                      onClick={() => setActiveTab(idx)}
                      className={activeTab === idx ? "font-semibold text-black" : "text-gray-400 hover:text-gray-600"}
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                {/* Step 1 */}
                {activeTab === 0 && (
                  <div className="grid md:grid-cols-2 gap-6">
                    <div>
                      <p className="mb-4 text-gray-700 font-medium">Choose your Amount</p>
                      <div className="flex flex-col gap-3">
                        {["15.000", "25.000", "50.000", "100.000"].map((amt) => (
                          <button
                            key={amt}
                            onClick={() => setAmount(amt)}
                            className="flex items-center gap-2 border border-gray-300 rounded-lg px-4 py-2 hover:border-green-600 hover:bg-green-50 transition"
                          >
                            <span className="bg-green-100 p-2 rounded-full">💰</span>
                            $ {amt}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div>
                      <p className="mb-4 text-gray-700 font-medium">Other nominal</p>
                      <div className="flex items-center border border-gray-300 rounded-lg px-3 py-2 mb-4">
                        <select className="bg-transparent outline-none text-gray-700" value={currency} onChange={(e) => setCurrency(e.target.value)}>
                          <option>$</option>
                          <option>₹</option>
                          <option>€</option>
                        </select>
                        <input
                          type="number"
                          className="ml-2 flex-1 outline-none bg-transparent"
                          placeholder="0"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                        />
                      </div>
                      <button
                        className="w-full bg-green-800 text-white py-3 rounded-full font-medium hover:bg-green-700 transition"
                        onClick={handleAddAmount}
                        disabled={loading}
                      >
                        {loading ? "Processing..." : "Add Amount"}
                      </button>
                      {message && <p className="mt-3 text-green-700 font-medium">{message} (Balance: ${balance})</p>}
                    </div>
                  </div>
                )}

                {/* Step 2 */}
                {activeTab === 1 && (
                  <div className="w-full max-w-2xl mx-auto bg-white p-6">
                    <div className="flex items-center justify-between px-4 py-3 border rounded-lg bg-green-50 mb-4">
                      <span>{currency}</span>
                      <span className="font-medium">{amount !== "" ? amount : "0"}</span>
                    </div>
                    <div className="border rounded-lg p-4 mb-4">
                      <div className="flex justify-between items-center">
                        <div>
                          <p className="text-sm font-medium text-gray-700">Payment method</p>
                          <p className="font-semibold text-indigo-900">Credit/Debit Card</p>
                        </div>
                        <button className="px-3 py-1 border rounded-lg text-sm text-gray-600 hover:bg-gray-100">Change</button>
                      </div>
                    </div>
                    <div className="mb-2">
                      <label className="text-sm text-gray-700 font-medium">Write your wish and encouragement</label>
                      <textarea
                        className="w-full border rounded-lg mt-1 p-3 text-sm focus:ring-2 focus:ring-green-600 outline-none"
                        rows="3"
                        maxLength="200"
                        placeholder="Write your wish to support them"
                      />
                      <div className="flex justify-between text-xs text-gray-400 mt-1">
                        <span>0/200</span>
                        <span>Optional text</span>
                      </div>
                    </div>
                    <button
                      className="w-full bg-green-800 text-white font-medium py-3 rounded-full mt-4 hover:bg-green-900"
                      onClick={() => setActiveTab(2)}
                    >
                      Pay Now
                    </button>
                  </div>
                )}

                {/* Step 3 */}
                {activeTab === 2 && (
                  <div className="w-full max-w-2xl mx-auto bg-white p-6 rounded-lg">
                    <div className="mb-4">
                      <label className="block text-sm font-medium text-gray-800 mb-2">Card details</label>
                      <div className="border border-green-400 rounded-xl px-4 py-3 bg-white">
                        <CardElement
                          options={{
                            style: {
                              base: { fontSize: "16px", color: "#222", "::placeholder": { color: "#888" }, fontFamily: "inherit" },
                              invalid: { color: "#BE1F2E" },
                            },
                          }}
                        />
                      </div>
                    </div>
                    <button
                      className="w-full bg-green-900 text-white font-medium py-3 rounded-full hover:bg-green-800"
                      onClick={handleWalletPayment}
                      disabled={loading}
                    >
                      {loading ? "Processing..." : "Pay Now"}
                    </button>
                    {message && <p className="mt-3">{message}</p>}
                  </div>
                )}
              </div>
            )}
          </div>

          <Rightsidebar />
        </main>
      </main>

      {/* ── Create Family Wallet Modal ── */}
      {showFamilyModal && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={closeFamilyModal}
        >
          <div
            className="bg-white w-full max-w-5xl rounded-2xl p-8 shadow-xl relative max-h-[90vh] overflow-y-auto [&::-webkit-scrollbar]:hidden [scrollbar-width:none]"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Header row: logo + close */}
            <div className="flex items-start justify-between mb-6">
              <p className="text-3xl font-bold text-gray-900 tracking-tight">Pipaan</p>
              <button
                className="w-9 h-9 bg-[#095228] text-white rounded-full flex items-center justify-center text-base font-bold hover:bg-green-900 transition flex-shrink-0"
                onClick={closeFamilyModal}
              >
                ✕
              </button>
            </div>

            {/* Title - Family Wallet - Siddharth */}
            <h2 className="text-xl font-bold text-[#095228] mb-6">
              {isEditMode ? familyName : "Create Family Wallet"}
            </h2>

            {/* Family Wallet Name - Family Wallet - Siddharth: hidden in Add Member mode, no rename support */}
            {!isEditMode && (
              <div className="mb-5">
                <label className="block text-sm font-medium text-gray-800 mb-2">Family Wallet Name</label>
                <input
                  type="text"
                  placeholder="e.g., Sharma Family Wallet"
                  value={familyName}
                  onChange={(e) => setFamilyName(e.target.value)}
                  className="w-full border border-gray-300 rounded-xl px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-[#095228]"
                />
              </div>
            )}

            {/* Add Member + Relationship */}
            <div className="grid grid-cols-2 gap-4 mb-3">
              <div>
                <label className="block text-sm font-medium text-gray-800 mb-2">Add Family Member</label>
                <div className="flex items-center gap-2 border border-gray-300 rounded-xl px-3 py-2.5">
                  <img src={require("../assets/images/icons/Search-2.png")} alt="search" className="w-4 h-4 opacity-40 flex-shrink-0" />
                  <input
                    type="text"
                    placeholder="Search Family Member"
                    value={memberSearch}
                    onChange={(e) => setMemberSearch(e.target.value)}
                    className="flex-1 text-sm outline-none bg-transparent text-gray-600 placeholder-gray-400"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-800 mb-2">Relationalship</label>
                <div className="relative">
                  <select
                    value={relationship}
                    onChange={(e) => setRelationship(e.target.value)}
                    className="w-full appearance-none border border-gray-300 rounded-xl px-4 py-3 text-sm text-gray-500 outline-none focus:ring-2 focus:ring-[#095228] bg-white"
                  >
                    <option value="">Select Relationalship</option>
                    <option>Spouse</option>
                    <option>Parent</option>
                    <option>Child</option>
                    <option>Sibling</option>
                    <option>Other</option>
                  </select>
                  <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-xs">▼</span>
                </div>
              </div>
            </div>

            {/* Family Wallet - Siddharth: real search results, works in both Create and Add-Member modes */}
            {searchResults.map((result) => (
              <div key={result.family_member_id} className="flex items-center justify-between py-3 border-b border-gray-200 mb-6 max-w-3xl">
                <div className="flex items-center gap-3">
                  <img
                    src={result.user?.profile_picture_url || require("../assets/images/golive-prf.png")}
                    alt="member"
                    className="w-12 h-12 rounded-full object-cover flex-shrink-0"
                  />
                  <div>
                    <p className="font-bold text-gray-900 text-sm">{result.user?.first_name} {result.user?.last_name}</p>
                    <p className="text-xs text-gray-400">@{result.user?.username}</p>
                  </div>
                </div>
                <button
                  disabled={invitingMemberId === result.family_member_id}
                  className="bg-[#095228] text-white text-sm font-semibold px-5 py-2 rounded-full hover:bg-green-900 transition disabled:opacity-60"
                  onClick={() => (isEditMode ? inviteMemberNow(result) : addPendingMember(result))}
                >
                  {isEditMode
                    ? (invitingMemberId === result.family_member_id ? "Sending..." : "Send Invite")
                    : "Add"}
                </button>
              </div>
            ))}

            {/* Submit - Family Wallet - Siddharth: left-aligned, full-width to match Load Amount button style */}
            {!isEditMode && (
              <button
                type="button"
                disabled={creatingFamilyWallet}
                className="w-full max-w-3xl block bg-[#095228] text-white font-semibold py-3 rounded-full hover:bg-green-900 transition mb-6 disabled:opacity-60"
                onClick={createFamilyWallet}
              >
                {creatingFamilyWallet ? "Creating..." : "Create Family Wallet"}
              </button>
            )}

            {/* Family Wallet - Siddharth: hidden until at least one member has been added */}
            {!isEditMode && pendingMembers.length > 0 && (
              <>
                {/* Family Members List - Family Wallet - Siddharth */}
                <h3 className="text-lg font-bold text-[#095228] mb-4">Family Members List</h3>
                <div className="space-y-3">
                  {pendingMembers.map((member) => (
                    <div key={member.family_member_id} className="p-[0.5px] rounded-2xl bg-gradient-to-r from-[#98911F] to-[#39B54A] max-w-3xl">
                      <div className="flex items-center justify-between bg-[#FEFDEB] rounded-2xl px-4 py-3">
                        <div className="flex items-center gap-3">
                          <img
                            src={member.user?.profile_picture_url || require("../assets/images/golive-prf.png")}
                            alt="member"
                            className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                          />
                          <div>
                            <div className="flex items-center gap-1.5 flex-wrap">
                              <p className="font-bold text-gray-900 text-sm">{member.user?.first_name} {member.user?.last_name}</p>
                              <span className="text-gray-900 text-[10px] font-bold px-2 py-0.5 rounded-full bg-gradient-to-r from-[#A1D2FF] to-[#00E0C6]">{member.relationship_type}</span>
                            </div>
                            <p className="text-xs text-gray-400 mt-0.5">@{member.user?.username}</p>
                          </div>
                        </div>
                        <button
                          className="bg-[#F9E9EA] border border-[#BE1F2E] text-[#BE1F2E] text-xs font-semibold px-3 py-2 rounded-full hover:opacity-80 transition"
                          onClick={() => removePendingMember(member.family_member_id)}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            {/* Family Wallet - Siddharth: real member list in Add-Member mode */}
            {isEditMode && (
              <>
                <h3 className="text-lg font-bold text-[#095228] mb-4">Family Members List</h3>
                {familyMembers.length === 0 && (
                  <p className="text-sm text-gray-400 mb-4">No member yet</p>
                )}
                <div className="space-y-3">
                  {familyMembers.map((member) => (
                    <div key={member.family_wallet_member_id} className="p-[0.5px] rounded-2xl bg-gradient-to-r from-[#98911F] to-[#39B54A] max-w-3xl">
                      <div className="flex items-center justify-between bg-[#FEFDEB] rounded-2xl px-4 py-3">
                        <div className="flex items-center gap-3">
                          <img
                            src={member.user?.profile_picture_url || require("../assets/images/golive-prf.png")}
                            alt="member"
                            className="w-11 h-11 rounded-full object-cover flex-shrink-0"
                          />
                          <div>
                            <div className="flex items-center gap-1.5 flex-wrap">
                              <p className="font-bold text-gray-900 text-sm">{member.user?.first_name} {member.user?.last_name}</p>
                              <span className="text-gray-900 text-[10px] font-bold px-2 py-0.5 rounded-full bg-gradient-to-r from-[#A1D2FF] to-[#00E0C6]">{member.relationship_type}</span>
                              {/* Family Wallet - Siddharth: status badge for all three states, not just pending */}
                              {member.status === "pending" && (
                                <span className="bg-[#F9E9EA] text-[#BE1F2E] text-[10px] font-semibold px-2 py-0.5 rounded">Request Pending</span>
                              )}
                              {member.status === "accepted" && (
                                <span className="bg-[#E6F7EC] text-[#095228] text-[10px] font-semibold px-2 py-0.5 rounded">Active</span>
                              )}
                              {member.status === "rejected" && (
                                <span className="bg-[#F9E9EA] text-[#BE1F2E] text-[10px] font-semibold px-2 py-0.5 rounded">Rejected</span>
                              )}
                            </div>
                            <p className="text-xs text-gray-400 mt-0.5">@{member.user?.username}</p>
                          </div>
                        </div>
                        {/* Family Wallet - Siddharth: Load Money / Delete hidden here for now, caption removed per feedback */}
                        <div className="flex items-center gap-2">
                          <div className="text-right mr-1">
                            <p className="font-bold text-gray-900 text-base">$ {member.current_balance}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* ── OTP Verification Modal ── */}
      {showOtpModal && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => setShowOtpModal(false)}
        >
          <div
            className="bg-white w-full max-w-2xl rounded-3xl px-10 py-10 shadow-xl relative text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="absolute top-6 right-6 w-9 h-9 bg-[#095228] text-white rounded-full flex items-center justify-center text-sm font-bold hover:bg-green-900 transition"
              onClick={() => setShowOtpModal(false)}
            >
              ✕
            </button>

            <h2 className="text-2xl font-bold text-gray-900 mb-4">OTP Verification</h2>
            <p className="text-sm text-gray-500 mb-6 leading-relaxed">
              Enter the verification code we just sent to your number +91 94 *******53.
            </p>

            <input
              type="text"
              placeholder="Enter Verification Code"
              value={otpValue}
              onChange={(e) => setOtpValue(e.target.value)}
              className="w-full border border-gray-300 rounded-xl px-4 py-3 text-sm text-center text-gray-700 placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#095228] mb-4"
            />

            {/* Family Wallet - Siddharth */}
            {otpError && (
              <p className="text-red-600 text-sm font-medium mb-2">{otpError}</p>
            )}

            <p className="text-red-600 font-bold text-sm mb-2">05:00</p>
            <p className="text-sm text-gray-700 mb-6">
              Didn't receive a code?{" "}
              <span
                className="text-[#095228] font-bold cursor-pointer hover:underline"
                onClick={initiateLoadMoney}
              >
                Resend
              </span>
            </p>

            <button
              type="button"
              disabled={!otpValue || verifyingOtp}
              onClick={confirmLoadMoneyOtp}
              className={`w-full font-bold py-3 rounded-xl transition ${
                otpValue && !verifyingOtp ? "bg-[#095228] text-white hover:bg-green-900" : "bg-gray-400 text-white cursor-not-allowed"
              }`}
            >
              {verifyingOtp ? "Verifying..." : "Verify"}
            </button>
          </div>
        </div>
      )}

      {/* ── Wallet Recharge Success Modal ── */}
      {showSuccessModal && (
        <div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
          onClick={() => {
            setShowSuccessModal(false);
            setShowLoadMoney(false);
            setLoadAmount("");
            setSelectedMember(null);
            setConfirmResult(null);
          }}
        >
          <div
            className="bg-white w-full max-w-2xl rounded-3xl px-10 py-10 shadow-xl relative text-center"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="absolute top-6 right-6 w-9 h-9 bg-[#095228] text-white rounded-full flex items-center justify-center text-sm font-bold hover:bg-green-900 transition"
              onClick={() => {
                setShowSuccessModal(false);
                setShowLoadMoney(false);
                setLoadAmount("");
                setSelectedMember(null);
                setConfirmResult(null);
              }}
            >
              ✕
            </button>

            {/* Success icon */}
            <div className="w-32 h-32 mx-auto mb-6">
              <img src={require("../assets/images/icons/Isolation_Mode.svg").default} alt="success" className="w-full h-full" />
            </div>

            <h2 className="text-2xl font-bold text-gray-900 mb-2">Thank You for Supporting!</h2>
            <p className="text-sm text-[#474747]">Your wallet recharge has been successfully sent to</p>
            {/* Family Wallet - Siddharth */}
            <p className="text-sm font-semibold mb-5 inline-block bg-gradient-to-r from-[#98911F] to-[#39B54A] bg-clip-text text-transparent">
              @{selectedMember?.user?.username}
            </p>

            <p className="text-sm text-[#474747] mb-1">Total Payment</p>
            {/* Family Wallet - Siddharth */}
            <p className="text-3xl font-bold text-gray-900 mb-2">
              ${confirmResult?.amount}
            </p>
            <p className="text-xs text-[#121212]">
              {confirmResult?.transaction_at
                ? new Date(confirmResult.transaction_at).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
                : ""}
              {confirmResult?.transaction_at && ", "}
              {confirmResult?.transaction_at
                ? new Date(confirmResult.transaction_at).toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit", hour12: false })
                : ""}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}


